module.exports = {
	"partner": {
		"realEstatePurchasePlanned": {
			"title": "Skal eller overvejer du at købe ny bolig ? Og kunne køberrådgivning have din interesse?"
		},
		"realEstatePurchaseTypes": {
			"title": "Hvilke type bolig?",
			"share": "Andelsbolig",
			"owner": "Ejerlejlighed",
			"enterprise": "Enterprise / Projektkøb",
			"parental": "Forældrekøb",
			"holiday": "Fritidsbolig",
			"leisure": "Grund",
			"country": "Landejendom",
			"villa": "Villa"
		},
		"timeBooking": {
			"title": "Fritekst vi kan bruge til at beskrive specifikke kundetilbud for partneren",
			"text": "Hvornår ønsker du at booke et møde med juristen?",
			"createUser": "Book møde"
		},
		"shouldShowDocuments": {
			"title": "Du har nu mulighed for",
			"text1": "1) At aktivere dit tilbud og booke et møde med en af vores jurister med det samme.",
			"text2": "2) At få mere information om vores produkter, før du booker dit møde.",
			"yes": "Book møde nu",
			"no": "Få mere information"
		},
		"documents": {
			"text": "Hvilke dokumenter ønsker du at gennemgå på mødet?",
			"addProduct": "Tilføj produkt",
			"price": "Tilføj produkt",
			"selectDocument": "Vælg dokument(er)",
			"selectType": "Vælg rådgivningstype",
			"error": "Du skal vælge et dokument",
			"genericError": "Noget gik galt. Prøv igen, eller kontakt vores support.",
			"duplicateDocumentsError": "Du skal vælge to forskellige produkter",
			"selectDocumentPlaceholder": "Vælg dokument",
			"selectTypePlaceholder": "Vælg købstype"
		},
		"external": {
			"validation": {
				"title": "Vi har sendt dig en e-mail",
				"title_success": "Din e-mail er nu valideret. Du bliver automatisk sendt videre.",
				"description": "Vi har brug for at få valideret din e-mail adresse fra {partner}. Vi har derfor sendt en e-mail til <strong>{email}</strong>, hvor i du finder et link du skal trykke på. Når du har trykket på linket i e-mailen, kan du vende tilbage hertil, hvor du vil have fået adgang.",
				"cta": "Gå videre"
			}
		},
		"consent": {
			"title": "Lad vores Livsguide holde dig opdateret",
			"content": "Vil du give os mulighed for at kontakte dig pr. e-mail, sms eller ved opkald for at fortælle om fordelene ved TestaVivas juridiske dokumenter, samt tilskynde til at du gør brug af tilbuddet på den bedst mulige måde for dig? Det kræver, at du giver os samtykke hertil. Du kan altid tilbagekalde dit samtykke under \"Mine oplysninger\" på Testaviva.dk.",
			"confirm": "Vil du give os dit samtykke?",
			"conditions": "Læs om TestaVivas privatlivspolitik her.",
			"thanks": "Tak - husk at du altid kan tilbagekalde dit samtykke under Mine Oplysninger."
		},
		"signup": {
			"process": "Følg processen der er beskrevet her: https://intranet.testaviva.dk/ud-udvikling/ud3-fejlsogning-pa-produktion/ud03-01-indrapportering-af-fejl-pa-henvisningslosningen/",
			"title": "Velkommen til TestaViva",
			"content": "For at aktivere dit tilbud fra {partner}, bedes du udfylde nedenstående.",
			"contentAdvisor": "Hele formularen SKAL udfyldes af rådgiver.",
			"fullName": "Navn",
			"firstName": "Fornavn(e)",
			"lastName": "Efternavn(e)",
			"email": "E-mail",
			"firstUser": "Bruger 1",
			"secondUser": "Bruger 2",
			"phone": "Telefon",
			"primary": "Angiv som primære kontakt",
			"addPartner": "Tilføj information for partner",
			"branchAdvisorTitle": "Information om rådgiver",
			"advisorId": "Rådgiver",
			"yourAdvisorId": "Indtast din bankrådgivers navn",
			"branchId": "Filial",
			"branchIdChoose": "Vælg filial",
			"single_title": "Informationer om dig",
			"multiple_title": "Informationer om jer",
			"comment": "Har du nogle kommentarer til TestaViva?",
			"partnerTitle": "Partnerens information",
			"partnerDescription": "Hvis du har en partner, der også ønsker at oprette og have adgang til tilbuddet fra {partner}, skal din partner selv indtaste sine informationer herunder.",
			"product": {
				"review": "Juridisk tjek",
				"diy": "Gør det selv",
				"guidance": "Udvidet rådgivning"
			},
			"single_description": "Information må kun indtastes, hvis personen er til stede på mødet.",
			"multiple_description": "Information må kun indtastes, hvis personerne er til stede på mødet.",
			"phoneOrFaceToFaceMeeting": {
				"question": "Deltager kunden i et fysisk eller i et telefonisk møde",
				"faceToFace": "Fysisk",
				"phone": "Telefonisk"
			},
			"sharingScreenWithCustomer": {
				"question": "Deler du skærmen med kunden?"
			},
			"isPartnerPresentAtMeeting": {
				"question": "Deltager kundens partner også på mødet?"
			},
			"errors": {
				"userFirst": {
					"firstname": "Du skal angive dit fornavn",
					"lastname": "Du skal angive dit efternavn",
					"advisorId": "Du skal angive et rådgiver ID",
					"branchId": "Du skal vælge en filial",
					"email": "Du skal angive din e-mail",
					"emailInvalid": "Din e-mail adresse er ugyldig",
					"phone": "Du skal angive dit telefonnummer"
				},
				"userSecond": {
					"firstname": "Du skal angive partnerens fornavn",
					"lastname": "Du skal angive partnerens efternavn",
					"advisorId": "Du skal angive et rådgiver ID",
					"branchId": "Du skal vælge en filial",
					"email": "Du skal angive partnerens e-mail",
					"emailInvalid": "Partnerens e-mail adresse er ugyldig",
					"phone": "Du skal angive partnerens telefonnummer"
				},
				"consent": "Du skal tage stilling til samtykket",
				"error": "Der skete desværre en fejl og vi kunne ikke gemme oplysningerne. Prøv igen eller kontakt os på 88 62 60 50 eller support@testaviva.dk.",
				"mail": "E-mail adressen {email} er ikke gyldig. Angiv en gyldig e-mail og prøv at gemme igen.",
				"advisorId": "Du skal angive et gyldigt rådgiver ID",
				"error_create_ticket_subject": "Fejl i henvisningsløsningen"
			},
			"completeTitle": "Tak! Michael fra TestaViva har sendt dig en mail",
			"completeContentStart": "<p> Tjek din indbakke og følg linket i mailen. Så guider TestaViva dig igennem processen med at oprette juridiske dokumenter og få udvidet juridisk rådgivning. </p> <p><strong>Husk at tjekke dit spamfilter – mailen kan være havnet der.</strong></p>",
			"completeContentEnd": "<p> TestaViva ser frem til at hjælpe dig med at få styr på dine juridiske dokumenter, som er relevante for dig og din familie. </p> <p> Der kan være udgifter til notar eller tinglysning, og TestaViva oplyser om dette under oprettelsen af dine dokumenter. </p> <p>Hilsen TestaViva</p>",
			"quote": "<p>\"God fornøjelse!\"</p> <p>Michael Lauritzen, Co-founder af TestaViva</p>",
			"advancedAlone": "De følgende spørgsmål vil give TestaViva mulighed for bedre at udvælge de dokumenter, som er relevante for dig.",
			"advancedPartner": "De følgende spørgsmål vil give TestaViva mulighed for bedre at udvælge de dokumenter, som er relevante for jer.",
			"marital": {
				"title": "Civilstand",
				"single": "Single",
				"partnership": "I forhold",
				"married": "Gift",
				"partnersNotMarried": "I forhold"
			},
			"living": "Bor I sammen?",
			"marriagePlanned": "Skal I giftes indenfor de næste seks måneder?",
			"childrenAlone": "Har du børn?",
			"childrenPartner": "Har I børn sammen?",
			"ownChildrenAlone": "Har du børn fra et tidligere forhold?",
			"ownChildrenPartner": "Har nogen af jer børn fra et tidligere forhold?",
			"documents": {
				"titleAlone": "Er der produkter som er særligt interessante for dig?",
				"titlePartner": "Er der produkter som er særligt interessante for jer?"
			},
			"assets": {
				"titleAlone": "Hvor er din formue placeret?",
				"titlePartner": "Hvor er jeres formue placeret?",
				"property": "Bolig",
				"saving": "Opsparing / Investering",
				"pension": "Pension",
				"value": "Anden formue"
			},
			"save": "Fortsæt",
			"finish": "Gem og afslut",
			"consent": {
				"title": "Lovpligtigt Samtykke",
				"marketing": "Marketing",
				"notifications": "Notifikationer",
				"partner_communication": "Kommunikation med partner",
				"partner_usage": "Partner må bruge data",
				"partner_call": "Ringe til brugeren",
				"partner_call_8_12": "Ringe til brugeren mellem 8-12",
				"partner_call_12_17": "Ringe til brugeren mellem 12-17",
				"partner_call_17_21": "Ringe til brugeren mellem 17-21",
				"partner_call_9_15": "Ringe til brugeren mellem 9-15",
				"partner_call_15_21": "Ringe til brugeren mellem 15-21",
				"partner_email": "Sende mails til brugeren",
				"partner_send_data": "TestaViva må sende data til Partneren",
				"testaviva_send_data": "Partneren må sende data til TestaViva",
				"subtext": {
					"faceToFace": "Du skal som kunde selv klikke af, om du vil afgive samtykke til nedenstående.",
					"remote": "Du skal som kunde have læst samtykket op af rådgiveren, og herefter skal du selv sige ja eller nej."
				},
				"choseTimeForCall": "I hvilket tidsrum vil du gerne ringes op af TestaViva og TestaLegal?",
				"retractConsent": "Du kan til enhver tid tilbagekalde ovenstående samtykke, ved at sende os en mail på support@testaviva.dk eller på www.testaviva.dk/tilbagekald_samtykke."
			},
			"conditions": {
				"call": "Må TestaViva ringe dig op og minde dig om tilbuddet?",
				"email": "Må TestaViva sende dig mails for at minde dig om tilbuddet?",
				"data": "Er du indforstået med, at TestaViva modtager alle gennemgåede oplysninger for at give dig adgang til TestaViva med henblik på at oprette juridiske dokumenter?",
				"usage": "Du kan finde TestaVivas privatlivspolitik <a href=\"https://testaviva.dk/privatlivspolitik\" target=\"_blank\">her</a>."
			},
			"data_partner": "Er I indforstået med, at TestaViva modtager alle gennemgåede oplysninger for at give jer adgang til TestaViva med henblik på at oprette juridiske dokumenter?",
			"data_nopartner": "Er du indforstået med, at TestaViva modtager alle gennemgåede oplysninger for at give dig adgang til TestaViva med henblik på at oprette juridiske dokumenter?",
			"choice": "Vælg",
			"guidance": "Udvidet rådgivning",
			"review": "Juridisk tjek"
		},
		"modal": {
			"title": "Kære <strong>{name}</strong>",
			"description_first": "Du er få skridt fra at blive bruger på TestaViva",
			"description_second": "Du er nu ét skridt fra at blive bruger på TestaViva.",
			"description_existing": "Du har allerede en bruger hos TestaViva og skal nu logge ind, ved at indtaste dit eksisterende kodeord.<br />Kan du ikke huske kodeordet, kan du nulstille det ved at trykke <a href=\"/resetting/request\" target=\"_blank\">her</a>.",
			"email": "E-mail",
			"password": "Kodeord",
			"passwordHint": "Dit kodeord skal være på min. 6 tegn og indeholde min. et tal og et bogstav.",
			"passwordInput": "Angiv dit kodeord til din TestaViva bruger.",
			"passwordRepeat": "Gentag kodeord",
			"conditions": "<span>Jeg accepterer TestaVivas <a href=\"https://testaviva.dk/vilkaar\" target=\"_blank\">regler og betingelser</a></span>.",
			"next": "Fortsæt",
			"back": "Tilbage",
			"no": "Nej",
			"yes": "Ja, selvfølgelig",
			"errors": {
				"password": "Du skal indtaste et kodeord",
				"passwordWrong": "Du har angivet et forkert kodeord.",
				"passwordRepeat": "Det indtastede kodeord er ikke ens.",
				"conditions": "Du skal bekræfte betingelserne.",
				"save": "Vi kunne ikke gemme dit kodeord. Prøv igen, eller kontakt support@testaviva.dk."
			}
		}
	}
};